$(function () {
    var $productPopup = $('#product-popup'),
        $myCartCount = $('.js-my-cart-count'),
        $body=$('body'),
        productID=0,
        offerID=0,
        article='';

    function fillProductPopup(response) {
        if(response.status!=='ok'){
            return false;
        }
        productID = response.data.ID;
        offerID   = response.data.OFFERS[0].ID;
        article   = response.data.OFFERS[0].PROPERTY_ARTNUMBER_VALUE;

        var thumbnails='',details='',sizes='',discountBlock='',i,t=false,additionClass='';
        for (i = 0; i < response.data.GALLERY.length; i++) {
            thumbnails += '<div class="popup-product-gallery__thumbnail-item js-thumb-item" style="background-image: url(\'' + response.data.GALLERY[i] + '\')" data-num="' + i + '"></div>';
            details += '<div class="popup-product-gallery__detail-picture"  style="background-image: url(\'' + response.data.GALLERY[i] + '\')"></div>';

        }
        var offers = response.data.OFFERS;
        for( i=0;i<offers.length;i++){
            if(offers[i].PROPERTY_SIZES_CLOTHES_VALUE!==''){
                if (!t) {
                    additionClass = '_active';
                    t=true;
                }else{
                    additionClass = '';
                }
                if(!(offers[i].PROPERTY_SIZES_CLOTHES_VALUE)){
                    additionClass += ' _hidden';
                }
                if((offers[i].PROPERTY_SIZES_CLOTHES_VALUE)=='one size' || (offers[i].PROPERTY_SIZES_CLOTHES_VALUE)=='one size x'){
                    additionClass += ' _big';
                }
                sizes+='<div ' +
                    'class="state-pic _pinker-bg _pointer _size '+additionClass+' js-popup-select-size" ' +
                    'data-article="'+offers[i].PROPERTY_ARTNUMBER_VALUE+'"' +
                    'data-offer-price="'+ response.data.PRICE_DATA.OFFERS_PRICE[offers[i].ID].DISCOUNT_PRICE + ' руб"' +
                    'data-offer-id="'+offers[i].ID+'" ' +
                    '>'+offers[i].PROPERTY_SIZES_CLOTHES_VALUE+'</div>';
            }
        }
        if (response.data.PRICE_DATA.RESULT_PRICE.BASE_PRICE!==response.data.PRICE_DATA.RESULT_PRICE.DISCOUNT_PRICE) {
            discountBlock = '<div class="price-discount _left">' + response.data.PRICE_DATA.RESULT_PRICE.BASE_PRICE + ' руб</div>'
        }
        var description = response.data["~DETAIL_TEXT"] ? '<div class="popup-product-detail__description">\n' +
'                                        <div class="popup-product-detail__description _title">Описание</div>\n' +
'                                        <div class="popup-product-detail__description _text">\n' +
'                                            '+response.data["~DETAIL_TEXT"]+'\n' +
'                                            </div>\n' +
'                                    </div>\n' : '';

        var showBuyButton = '';
        if (response.data['HIDE'] !== 1) {
            showBuyButton = '<div class="button">\n' +
                '                                <a class="full-size-href js-popup-make-order" href="/personal/cart/">\n' +
                '                                    ДОБАВИТЬ В КОРЗИНУ\n' +
                '                                </a>\n' +
                '                            </div>';
        }


        $productPopup.html('<div class="popup-overlay js-product-popup-close" data-target="#product-popup"></div>\n' +
            '                    <div class="popup-wrap">\n' +
            '                        <div class="popup-close js-product-popup-close" data-target="#product-popup">\n' +
            '                            <svg class="popup-close-pic" >\n' +
            '                                <use xlink:href="#iconclose"></use>\n' +
            '                            </svg>\n' +
            '                        </div>\n' +
            '                        <div class="popup-product js-popup-product">\n' +
            '                            <div class="popup-product__left-column">\n' +
            '                                <div class="popup-product-gallery js-popup-product-gallery-wrap">\n' +
            '\n' +
            '                                    <div class="popup-product-gallery__detail-slider">\n' +
            '                                        <div class="popup-product-gallery__slider">\n' +
            '                                            <div class="popup-product-gallery__thumbnail-list js-product-thumbnails">\n' +
            '                                                '+thumbnails+' \n' +
            '                                            </div>\n' +
            '                                            <div class="popup-product-gallery__arrow _up js-popup-product-gallery-arrow js-popup-product-gallery-up"    >\n' +
            '                                                <svg class="gallery__arrow-pic" >\n' +
            '                                                    <use xlink:href="#iconarrow"></use>\n' +
            '                                                </svg>\n' +
            '                                            </div>\n' +
            '                                            <div class="popup-product-gallery__arrow _down js-popup-product-gallery-arrow js-popup-product-gallery-down">\n' +
            '                                                <svg class="gallery__arrow-pic" >\n' +
            '                                                    <use xlink:href="#iconarrow"></use>\n' +
            '                                                </svg>\n' +
            '                                            </div>\n' +
            '                                        </div>\n' +
            '                                        <div class="popup-product-gallery__detail-list js-product-detail">\n' +
            '                                            '+details+'\n' +
            '                                        </div>\n' +
            '                                        <div class="product__state">\n' +
            '                                            '+sizes+'\n' +
            '                                        </div>\n' +
            '                                    </div>\n' +
            '                                </div>\n' +
            '\n' +
            '                            </div>\n' +
            '                            <div class="popup-product__right-column">\n' +
            '                                <div class="popup-product-detail__head">\n' +
            '                                    <div class="popup-product-detail__title">\n' +
            '                                        '+response.data.TYPE+'<br>\n' +
            '                                        '+response.data.SHORT_NAME+'\n' +
            '                                    </div>\n' +
            '                                    <div class="popup-product-detail__price">'+response.data.PRICE_DATA.RESULT_PRICE.DISCOUNT_PRICE+' руб'+discountBlock+'</div>\n' +
            '                                </div>\n' +
            '                                <div class="popup-product-detail__body">\n' +
            '                                   ' + description + '\n' +
            '                                </div>\n' +
            '                                <div class="popup-product-detail-block__buttons _info">\n' +
            '                                    ' + showBuyButton + '\n' +
            '                                    <div class="button">\n' +
            '                                        <a class="full-size-href" href="/catalog/'+response.data.TYPE_CODE+'/'+response.data.CODE+'/">\n' +
            '                                            СТРАНИЦА ТОВАРА\n' +
            '                                        </a>\n' +
            '                                    </div>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                        </div>\n' +
            '                    </div>');
    }

    function showProductPopup(productID) {
        FridayApi.show('product', {id:productID}, function (data) {
            fillProductPopup(data);
            window.imageGaleryBlock($('.js-popup-product-gallery-wrap')).show();
        });
        $productPopup.removeClass('_hidden');
    }
    $body.on('click','.js-product-popup-close',function(){
        $productPopup.addClass('_hidden');
        $productPopup.html('');
    });
    $('.js-show-product-popup').click(function () {
        showProductPopup($(this).parents('.js-product-item').data('item-id'));
    });

    $body.on('click','.js-popup-select-size',function (e) {
        $('.js-popup-select-size').removeClass('_active');
        $(this).addClass('_active');
        article=$(this).data('article');
        offerID=$(this).data('offer-id');
    });
    $body.on('click','.js-popup-make-order',function (e) {
        e.preventDefault();

        var id=0;
        if(offerID!==0){
            id=offerID;
        }else{
            id=productID;
        }
        if(id>0) {
            FridayApi.create(
                'myCart',
                {
                    article: article,
                    count: 1,
                    id: id
                },
                function (data) {
                    if(data.status==='ok'){
                        FridayApi.index(
                            'myCart',
                            {},
                            function (dataReturned) {
                                $myCartCount.html(dataReturned.data.TOTAL_QUANTITY);
                                if(dataReturned.data.TOTAL_QUANTITY>0){
                                    $myCartCount.addClass('_active');
                                }else{
                                    $myCartCount.removeClass('_active');
                                }

                            }
                        )
                        var $btnOrder = $('.js-popup-make-order');
                        $btnOrder.html('перейти в корзину').removeClass('js-popup-make-order');
                    }else if(data.status==='error'){
                        $('#error-popup').removeClass('_hidden').find('.js-popup-body').html(data.code);
                    }
                });
        }
    });

/////////////////////////////////////////////////

});



//////////////////
// WEBPACK FOOTER
// ./src/js/product_popup.js
// module id = 6
// module chunks = 0 1 2